var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "washer-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 0.333374C6.00008 0.333374 0.666748 4.33337 0.666748 9.00004C0.666748 12.3334 2.66675 13.6667 6.00008 13.6667C9.33341 13.6667 11.3334 12.3334 11.3334 9.00004C11.3334 4.33337 6.00008 0.333374 6.00008 0.333374ZM6.00008 11.6667C5.55785 11.6835 5.11692 11.6087 4.70492 11.4471C4.29292 11.2855 3.91874 11.0406 3.6058 10.7277C3.29287 10.4147 3.04794 10.0405 2.88635 9.62854C2.72476 9.21654 2.65 8.77561 2.66675 8.33337C2.66675 8.15656 2.73699 7.98699 2.86201 7.86197C2.98703 7.73695 3.1566 7.66671 3.33341 7.66671C3.51023 7.66671 3.67979 7.73695 3.80482 7.86197C3.92984 7.98699 4.00008 8.15656 4.00008 8.33337C3.98596 8.59973 4.02803 8.86609 4.12354 9.11513C4.21906 9.36418 4.36589 9.59035 4.5545 9.77896C4.74311 9.96757 4.96928 10.1144 5.21832 10.2099C5.46737 10.3054 5.73372 10.3475 6.00008 10.3334C6.17689 10.3334 6.34646 10.4036 6.47149 10.5286C6.59651 10.6537 6.66675 10.8232 6.66675 11C6.66675 11.1769 6.59651 11.3464 6.47149 11.4714C6.34646 11.5965 6.17689 11.6667 6.00008 11.6667Z",
    fill: "#11232E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherIcon);
export default __webpack_public_path__ + "static/media/washer-icon.c48a05da7b1ac1d78837dc9fa6ab4efa.svg";
export { ForwardRef as ReactComponent };